<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed bootsnav light" />
    <HomeBanner :functions="meta.active_functions" :locations="meta.active_locations"></HomeBanner>
    <HotJobs :jobs="jobs" :config="config" v-if="jobs.length > 0" />
    <HomeAds />
    <HomeCarousel style="margin-top:140px;" />
    <HomeBlock/>
    <HomeRoll />
    <Footer :functions="meta.active_functions" />
    <SubscribeModal />
    <FollowModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import HomeBanner from '@/components/HomeBanner.vue'
import HotJobs from '@/components/HotJobs.vue'
import HomeAds from '@/components/HomeAds.vue'
import Footer from '@/components/Footer.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'
import HomeBlock from '@/components/HomeBlock.vue'
import HomeCarousel from '@/components/HomeCarousel.vue'
import HomeRoll from '@/components/HomeRoll.vue'
import FollowModal from '@/components/FollowModal.vue'

export default {
  name: 'home',
  props: ['config', 'meta'],
  components: {
    Nav,
    HomeBanner,
    HotJobs,
    HomeAds,
    Footer,
    SubscribeModal,
    HomeBlock,
    HomeCarousel,
    HomeRoll,
    FollowModal
  },
  data: () => ({
  jobs: [],
  blogs: []
  }),
  created: function() {
    let that = this,
        media = this.$route.query.s
    let query = {
        options: {
          page: 0,
          size: 8,
          sort: [{ create_at: 'desc' }]
        },
        query: {
          mandatory_filters: []
        }
    }
    //GA
    if (media != null && media!= '') {
      this.$ga.set({ 'campaignMedium': media })
    }
    this.$http.post(this.API_PREFIX + '/api/search/job?recommend=true', query).then(response => {
      that.jobs = response.data.hits
      that.jobs.forEach(job => {
        that.normalizeName(job.data.title)
        if(job.data.recruiting_company)
          that.normalizeCompany(job.data.recruiting_company.name)
      });
    }).catch(e => console.error(e));
  }
}
</script>
